import apiHelper from "../helper/ApiHelper";
import { showErrorToast } from "../utils/AlertUtils";

const ReportService = {
  async generateReport(reportType, headId = null) {
    try {
      let url = `/reports/generate?reportType=${reportType}`;
      if (reportType === "khatavahi" && headId) {
        url += `&headId=${headId}`;
      }
      const response = await apiHelper(url, "GET", null, {
        responseType: "blob", // Ensures proper binary handling
      });
      // const blob = response.data;
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${reportType}.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
      return true;
    } catch (error) {
      console.error("Error generating report:", error);
      showErrorToast(error.message);
      throw error;
    }
  },
};

export default ReportService;
